import { TextField } from '@mui/material';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Modal from '@mui/material/Modal';
import Typography from '@mui/material/Typography';
import React from 'react';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';

import postUpdateDeploymentDetails from '../../../../api/private/deployment/postUpdateSchedule';

function DeploymentConfirmationModal({
  onUpdateSuccess, open, onClose, onConfirm, onCancel, message, Log,
}) {
    const userName = useSelector((state) => state.user.userProfile.email);
  const UserGroup = useSelector((state) => state.user.userProfile.user_groupName);
     const Uservalidation = () => {
      if (UserGroup === 'SuperAdmin') {
        return true;
      }
      toast.error('Only SuperAdmin can cancel the deployment schedule');
      return false;
    };
  const [reason, setReason] = React.useState('');
  // const styles = {

  //   modal: {

  //     width: '300px',

  //     margin: 'auto',

  //     padding: '20px',

  //     border: '1px solid #ccc',

  //     borderRadius: '10px',

  //     textAlign: 'center',

  //   },

  //   line: {

  //     borderTop: '1px solid #ccc',

  //     margin: '20px 0',

  //   },

  //   buttonContainer: {

  //     display: 'flex',

  //     justifyContent: 'space-around',

  //   },

  //   button: {

  //     padding: '10px 20px',

  //     backgroundColor: '#f0f0f0',

  //     border: '1px solid #ccc',

  //     borderRadius: '5px',

  //     cursor: 'pointer',

  //   },

  //   disabledButton: {

  //     padding: '10px 20px',

  //     backgroundColor: '#e0e0e0',

  //     border: '1px solid #ccc',

  //     borderRadius: '5px',

  //     cursor: 'not-allowed',

  //   },

  // };

   const submitDeploymentSchedule = () => {
      if (!Uservalidation(userName)) {
        return;
      }
      try {
        const body = {
          LogId: Log.LogId,
          DeploymentMode: 'No',
          StartTime: Log.fromDateAndTime,
          EndTime: Log.toDateAndTime,
          createdBy: Log.userName,
          createdDate: new Date(),
          Status: 'Cancelled',
          ReleaseNote: Log.releaseNotes,
          Reason: reason,
        };
        postUpdateDeploymentDetails(body)
          .then((response) => {
            toast.success('Deployment schedule cancelled successfully');
            onUpdateSuccess(response.data);
          })
          .catch((err) => console.error(err));
      } catch (error) {
        console.error('Error submitting deployment schedule:', error);
      }
            onConfirm(reason);
    };

    const handleSubmitConfirm = () => {
      submitDeploymentSchedule();
    };
  return (
    <Modal open={open} onClose={onClose}>
<Box sx={{
 p: 3, background: '#fff', width: 400, margin: 'auto', mt: 10,
}}
>
<Typography>{message}</Typography>
<TextField
         fullWidth
         multiline
         rows={3}
         label="Reason for cancellation"
         value={reason}
         onChange={(e) => setReason(e.target.value)}
         sx={{ mt: 2 }}
/>
<Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
<Button onClick={onCancel}>Cancel</Button>
<Button
           variant="contained"
           color="error"
           sx={{ ml: 1 }}
           onClick={handleSubmitConfirm}
           disabled={!reason.trim()}
>
           Confirm
</Button>
</Box>
</Box>
    </Modal>
  );
}

export default DeploymentConfirmationModal;
